import request from '@/axios'


// 获取人员
export function Login(data={}) {
    return request({
        url: '/account/login',
        method: 'post',
        params: data
    })
}

// 修改密码
export function resetPass(data={}) {
    return request({
        url: '/account/changePassword',
        method: 'post',
        params: data
    })
}

